var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n\t"+_vm._s(_vm.showTitle)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }